import { useUser } from 'components/UserContext';
import { Navigate } from 'react-router-dom';

function RequireAuth({ children, redirectTo }) {
    const { isAuthenticated } = useUser();
    return isAuthenticated ? children : <Navigate to={redirectTo} />;
}

export default RequireAuth;